module.exports = __webpack_public_path__ + "img/waving-hand.949a4f42.png";